import { createFileRoute , Link } from "@tanstack/react-router";
import { useEffect } from "react";

import { PushNotificationsCard } from "@/features/push/PushNotificationsCard";
import { usePageHeader } from "@/shared/store/page-header";

export const Route = createFileRoute("/_authenticated/settings/")({
  component: SettingsPage,
});

function SettingsPage() {
  const { setTitle, reset } = usePageHeader();

  useEffect(() => {
    setTitle("Settings");
    return () => reset();
  }, [setTitle, reset]);

  return (
    <div className="mx-auto max-w-2xl p-6 sm:p-10 space-y-10">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">Settings</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Manage your account and integrations.
        </p>
      </div>
      <div className="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground">
        WhatsApp settings have moved to{" "}
        <Link to="/integrations" className="text-primary underline underline-offset-2 hover:no-underline">
          Integrations
        </Link>
        .
      </div>
      <PushNotificationsCard />
    </div>
  );
}
